import React from 'react';

interface ContentProps {
  text: string;
}

const Content: React.FC<ContentProps> = ({ text }) => {
  return (
    <>
      <p>{text}</p>
    </>
  )
};

export default Content;